export const MACRO_MCP_URL = 'https://mcp.atlas.solidum-invest.de/mcp';

export const ATLAS_MCP_CONFIG = JSON.stringify(
  {
    mcpServers: {
      atlas: {
        type: 'http',
        url: MACRO_MCP_URL,
      },
    },
  },
  null,
  2
);

export const CLI_COMMANDS = [
  {
    key: 'claude-cli',
    label: 'Claude Code',
    command: `claude mcp add --transport http atlas ${MACRO_MCP_URL}`,
  },
  {
    key: 'codex-cli',
    label: 'Codex CLI',
    command: `codex mcp add atlas --url ${MACRO_MCP_URL}`,
  },
] as const;

export const WEB_CLIENTS = [
  {
    key: 'claude-web',
    label: 'Claude.ai',
    hint: 'Settings → Connectors → Add custom connector',
  },
  {
    key: 'chatgpt-web',
    label: 'ChatGPT',
    hint: 'Settings → Apps → Advanced settings → enable Developer mode, then Create App',
  },
] as const;
